import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react';
import Joyride from 'react-joyride';
import type { LearningGuideController } from '../controllers/LearningGuide.controller';
import { TYPES } from '../ioc/types';
import type React from 'react';
import { toJS } from 'mobx';

export const LearningGuide: React.FC = observer(() => {
  const controller = useInjection<LearningGuideController>(TYPES.LearningGuideController);

  return (
    <Joyride
      {...toJS(controller.joyRideProps)}
      steps={toJS(controller.steps)}
      callback={(data) => {
        if (data.action === 'reset') {
          controller.stopGuide();
        }
      }}
    />
  );
});
